<div class="customer-register">
  <div class="customer-register__title">Register with the customer code</div>
  <form class="customer-register__form" [formGroup]="registerForm">
    <div class="customer-register__form-field">
      <label class="customer-register__form-field__label" for="code">Code</label>
      <input
        class="customer-register__form-field__input htv-selectable"
        id="code"
        type="text"
        systemkeyboard="true"
        formControlName="code"
        tabindex="-1" />
    </div>
    <div class="customer-register__form-field">
      <label class="customer-register__form-field__label" for="roomNumber">Room number</label>
      <input
        class="customer-register__form-field__input htv-selectable"
        id="roomNumber"
        type="text"
        systemkeyboard="true"
        formControlName="roomNumber"
        tabindex="-1" />
    </div>
    <button class="customer-register__submit htv-selectable" type="button" (click)="onSubmit()" tabindex="-1">
      OK
    </button>
    <div class="customer-register__message htv-error" *ngIf="message">{{ message }}</div>
  </form>
</div>
